import {makeStyles, Theme,} from '@material-ui/core/styles';

type ItemProps = {
    imgPath?: string,
};

export const makeSummaryDetailsList = makeStyles((theme: Theme) => ({
    container: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
    },

    item: ({ imgPath, }: ItemProps) => Object
        .assign(
            {},
            imgPath && {
                background: `url(${imgPath}) no-repeat `,
                backgroundSize: '4%',
                minHeight: 30,
                paddingLeft: 35,
                paddingTop: 5,
                marginTop: 10,
                backgroundPosition: 'left center',

                '& > ul': {
                    paddingLeft: 20,
                    listStyle: 'disc',
                }
            },
        ),
}));